import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, SlidersHorizontalIcon } from 'lucide-react';
import type { Tool } from '../../types/tools';
import { TOOLS } from '../../data/tools';
import { SectionHeading } from '../ui/SectionHeading';
import { Reveal } from '../ui/Reveal';
import { ToolIcon } from './ToolIcon';
import { trackEvent } from '../../utils/analytics';
export function ToolProcessFit({
  tool
}: {
  tool: Tool;
}) {
  const next = TOOLS.find(item => item.slug === tool.process.next.slug);
  return <section aria-labelledby="process-heading" className="border-b border-hairline-soft bg-ink" data-id="element-1259" data-mp="3jpq4z9nr0uc">
      <div className="mx-auto grid w-full max-w-[1320px] gap-12 px-4 py-20 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8 lg:py-24" data-id="element-1260" data-mp="hiyvt508mck2">
        <SectionHeading eyebrow="Fit with your fund’s process" headingId="process-heading" title={tool.process.heading} description={tool.process.body} data-id="element-1261" data-mp="cl74od7f2ugx" />

        <div className="flex flex-col gap-4" data-id="element-1262" data-mp="1o0c7dh7jst0j">
          <Reveal className="rounded-2xl border border-hairline bg-panel p-6" data-id="element-1263" data-mp="354ikccn9t4aa">
            <p className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.08em] text-text-secondary" data-id="element-1264" data-mp="3952hvhbra9wy">
              <SlidersHorizontalIcon className="h-4 w-4 text-lime" aria-hidden="true" data-id="element-1265" data-mp="3e5gs960txvy5" />
              Configure to your process
            </p>
            <ul className="mt-4 flex flex-wrap gap-2" data-id="element-1266" data-mp="3j1fhevtzfhzm">
              {tool.process.configurable.map(item => <li key={item} className="rounded-lg border border-hairline-soft bg-elevated px-3 py-1.5 text-[13px] text-text-primary" data-id="element-1267" data-mp="2qeuj1bf3a5mk">
                  {item}
                </li>)}
            </ul>
          </Reveal>

          {next ? <Reveal delay={0.06} data-id="element-1268" data-mp="3068os0xmw1o5">
              <Link to={`/tools/${next.slug}`} onClick={() => trackEvent('related_tool_click', {
            from_tool: tool.slug,
            to_tool: next.slug,
            placement: 'process'
          })} className="group flex items-center gap-4 rounded-2xl border border-[#E3DFF4] bg-[#FBFAFF] p-6 transition-shadow hover:shadow-[0_18px_40px_-28px_rgba(32,22,95,0.35)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime" data-id="element-1269" data-mp="306gyjjygmqv4">
                <ToolIcon name={next.icon} size="md" data-id="element-1270" data-mp="29cyu1q1hhrd9" />
                <span className="min-w-0 flex-1" data-id="element-1271" data-mp="24dvlvwq7j512">
                  <span className="block text-[15px] font-semibold text-text-primary" data-id="element-1272" data-mp="24f5liqcpkl9t">{tool.process.next.prompt}</span>
                  <span className="mt-1 block text-sm text-text-secondary" data-id="element-1273" data-mp="1gqmd8atns8hq">{next.cardDescription}</span>
                </span>
                <ArrowRightIcon className="h-5 w-5 shrink-0 text-lime transition-transform group-hover:translate-x-0.5 motion-reduce:transition-none" aria-hidden="true" data-id="element-1274" data-mp="1qnid5s5hrmao" />
              </Link>
            </Reveal> : null}
        </div>
      </div>
    </section>;
}